import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { BillsService } from "../../../injections/bills.service";

@Component({
    moduleId: module.id,
    selector: 'main-bills',
    templateUrl: '../templates/main-bills.html',
    providers: [],
})

export class MainBillsComponent implements OnInit {

    public bills: Array<object> = [];
    public paid: number;
    public type = "cleaner";
    constructor(private route: ActivatedRoute, private billsService: BillsService) { }

   
    ngOnInit() { 
       this.getCleanerBills();
    }

    public searchBills(event) {
        //console.log(event);
        this.type = event["type"];
        if(event["type"] == "cleaner"){
            if(event["data"] != ""){
                this.searchCleanerBills(event["data"]);
            }
        }else{
            if(event["data"] != ""){
                this.searchGYHBills(event["data"]);
            }
        }
    }

    public setFilterPaid(event) {
        this.paid = (event) ? 0 : null;
    }

    public searchGYHBills(data: object) {
        this.billsService.searchBillsGYH(data).subscribe(result => {
           this.bills = result;
       });
    }

    public searchCleanerBills(data: object) {
        this.billsService.searchBillsCleaner(data).subscribe(result => {
           this.bills = result;
       });
    }

    public getCleanerBills() {
        this.billsService.getCleanerBills().subscribe(result => {
           this.bills = result;
       });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/main-bills.component.ts